import React from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from 'react-redux'

import AltaPrestamoEm from './Deduccion/AltaPrestamoEm';
import IncrementoSalario from './Movimientos/IncrementoSalario';
import Baja from './Movimientos/Baja';

const AltaMovimiento = (props) => {
    const dispatch = useDispatch()
    const [tipo, setTipo] = React.useState('');

    const { lote } = props
    const { periodo } = props
    const { idempleado } = props
    const { activarbotontab } = props
    const { notificacion } = props
    const { empleadodepta } = props
    const {obtenerdatolote} = props
    const { datotodoempleado } = props

    const movimientos = useSelector(store => store.menus.movimientos)


    const handleChange = (event) => {
        setTipo(event.target.value);
    };


    return (
        <>
            <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={tipo}
                    label="Tipo"
                    onChange={handleChange}
                >
                    {
                        movimientos.map((row, Index) =>
                            <MenuItem key={Index} value={row.tipoMovimiento}>{row.descripcion}</MenuItem>
                        )
                    }

                </Select>
            </FormControl>

            {
                tipo === 1 ? (
                    <Baja
                        idempleado={idempleado}
                        lote={lote}
                        periodo={periodo}
                        notificacion={notificacion}
                        idconcepto={tipo}
                        empleadodepta={empleadodepta}
                        obtenerdatolote = {obtenerdatolote}
                        datotodoempleado={datotodoempleado}

                    />
                ) : null
            }
            {
                tipo === 2 ? (

                    <Baja
                        idempleado={idempleado}
                        lote={lote}
                        periodo={periodo}
                        notificacion={notificacion}
                        idconcepto={tipo}
                        empleadodepta={empleadodepta}
                        obtenerdatolote = {obtenerdatolote}
                        datotodoempleado={datotodoempleado}

                    />
                ) : null
            }
            {
                tipo === 3 ? (
                    <IncrementoSalario
                        idempleado={idempleado}
                        lote={lote}
                        periodo={periodo}
                        notificacion={notificacion}
                        idconcepto={tipo}
                        empleadodepta={empleadodepta}
                        obtenerdatolote = {obtenerdatolote}
                        datotodoempleado={datotodoempleado}

                    />
                ) : null
            }

        </>
    )
}

export default AltaMovimiento